import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=20fe70b0&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=20fe70b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe70b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fe70b0')) {
      api.createRecord('20fe70b0', component.options)
    } else {
      api.reload('20fe70b0', component.options)
    }
    module.hot.accept("./nav.vue?vue&type=template&id=20fe70b0&scoped=true", function () {
      api.rerender('20fe70b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/nav.vue"
export default component.exports